var _style, _path, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddPerson = function SvgAddPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "add-person_svg__Light",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".add-person_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 12.4c-.9-2.6-3.7-4-6.3-3.1C1.9 10 .5 11.9.5 14v3.5H3l.5 6h4l.5-6h1",
    className: "add-person_svg__st0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 4,
    r: 3.5,
    className: "add-person_svg__st0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 6,
    className: "add-person_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5v6M20.5 17.5h-6",
    className: "add-person_svg__st0"
  })));
};
export { SvgAddPerson as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxpZ2h0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI0IDI0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6bm9uZTtzdHJva2U6IzAwMDAwMDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7fQo8L3N0eWxlPgo8dGl0bGU+c2luZ2xlLW5ldXRyYWwtYWN0aW9ucy1hZGQ8L3RpdGxlPgo8Zz4KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMC4yLDEyLjRjLTAuOS0yLjYtMy43LTQtNi4zLTMuMWMtMiwwLjctMy40LDIuNi0zLjQsNC43djMuNUgzbDAuNSw2aDRsMC41LTZoMSIvPgoJPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iNS41IiBjeT0iNCIgcj0iMy41Ii8+Cgk8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIxNy41IiBjeT0iMTcuNSIgcj0iNiIvPgoJPGxpbmUgY2xhc3M9InN0MCIgeDE9IjE3LjUiIHkxPSIxNC41IiB4Mj0iMTcuNSIgeTI9IjIwLjUiLz4KCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSIyMC41IiB5MT0iMTcuNSIgeDI9IjE0LjUiIHkyPSIxNy41Ii8+CjwvZz4KPC9zdmc+Cg==";